import { useHistory } from 'react-router-dom'
import { Flex, Link, Text, Image, Box, Toggle, CheckmarkIcon, CloseIcon } from 'vvs-uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

import { TERMS_AND_CONDITIONS_URL, vvsgotchiDirectories } from 'config/constants/vvsgotchi'
import { socialMediaDataVvsGotchi } from 'config/constants/socialMediaData'

import { useVvsGotchiAudioModeManager } from 'state/vvsgotchi/hooks/useConfigManager'
import VvsGotchiWalletItem from './WalletItem'
import LinkMenuItem from './LinkMenuItem'
import { MenuDrawerContentFlex, LogoImg, Split, EmptyIcon } from './styles'

export const GradientsFont = styled(Text)<{ title: string }>`
  color: #4799cc;
  position: relative;
  &:before {
    position: absolute;
    content: '${({ title }) => title}';
    z-index: 10;
    color: #ffd600;
    -webkit-mask: linear-gradient(to left, #4799cc, transparent);
  }
`

const VvsGotchiMenuDrawerContent = ({ onClose }: { onClose: () => any }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { bgmPlay, toggleSetBgmMode, toggleSetSeMode } = useVvsGotchiAudioModeManager()

  return (
    <MenuDrawerContentFlex>
      <Flex p="2em 1em">
        <LogoImg src="/images/vvsGotchi/vvsgotchi_logo.png" alt="vvs gotchi logo" />
      </Flex>

      <VvsGotchiWalletItem />

      <Split mx={['1em', null, '2em']} my="1em" />

      <Flex flex="1" py="1.5em" flexDirection="column" alignItems="stretch">
        {vvsgotchiDirectories
          .map(({ Icon, ...opt }) => ({ Icon: Icon || EmptyIcon, ...opt }))
          .map(({ href, to, label, target, Icon }) => (
            <LinkMenuItem
              key={href || to}
              href={href}
              target={target}
              onClick={
                to
                  ? () => {
                      onClose()
                      history.push(to)
                    }
                  : undefined
              }
            >
              <Flex alignItems="center" mr="1em">
                <Icon width={24} height={24} />
              </Flex>
              <Text color="white" fontSize="20px" fontWeight="600">
                {label(t)}
              </Text>
            </LinkMenuItem>
          ))}
      </Flex>

      <Split mx={['1em', null, '2em']} my="1em" />

      <Flex mx={['1em', null, '2em']} flex="1" py="1.5em" alignItems="stretch">
        <Toggle
          defaultColor="extraBackground"
          checkedColor="primary"
          startIcon={(isActive = false) => isActive && <CloseIcon color="success" />}
          endIcon={(isActive = false) => isActive && <CheckmarkIcon color="primary" />}
          checked={bgmPlay}
          scale="md"
          onChange={() => {
            toggleSetBgmMode()
            toggleSetSeMode()
          }}
        />
        <Text ml="1em" color="white" fontSize="20px">
          {t('Sound Effects')}
        </Text>
      </Flex>

      <GradientsFont color="white" textAlign="center" fontSize="16px" fontWeight="500" title={t('FOLLOW US')}>
        {t('FOLLOW US')}
      </GradientsFont>

      <Box mt="1em" mb={['1em', null, '0']}>
        <Flex justifyContent="center">
          {socialMediaDataVvsGotchi.map((item, index) => {
            return (
              <Link
                key={item.src}
                external
                href={item.url}
                style={{ display: 'inline-block', width: 30, height: 30 }}
                mr={index !== socialMediaDataVvsGotchi.length - 1 ? '30px' : '0'}
              >
                <Image
                  src={item.src}
                  width={30}
                  height={30}
                  style={{
                    transform: `scale(${item.imgScale ?? 1})`,
                  }}
                />
              </Link>
            )
          })}
        </Flex>
      </Box>

      <Text m={['1em', null, '2em']} fontSize="11px" fontWeight="350" color="white">
        {t('All Rights Reserved VVSGotchi. All trademarks and copyrights belong to their respective owners.')}{' '}
        <Link
          href={TERMS_AND_CONDITIONS_URL}
          target="_blank"
          fontSize="11px"
          fontWeight="350"
          color="white"
          display="inline"
          underline="always"
        >
          {t('Terms & Conditions')}
        </Link>
      </Text>
    </MenuDrawerContentFlex>
  )
}

export default VvsGotchiMenuDrawerContent
